import { call, put, takeLatest, select } from 'redux-saga/effects';
import { 
    fetchCompanyInfoStart, 
    fetchCompanyInfoSuccess, 
    fetchCompanyInfoFailure, 
    loadCompanyInfoRequest 
} from '../companyInfoSlice';
import { getCompanyInfoApi } from '../../api/apiLists/getCompanyInfoApi';
import { callWithAuth } from '../sagaApiHelper';

// Cache timeout in milliseconds (10 minutes)
const CACHE_TIMEOUT = 10 * 60 * 1000;

function* handleFetchCompanyInfo() {
    try {
        // Check if data is already cached and fresh
        const companyInfo = yield select(state => state.companyInfo);
        const currentTime = new Date().getTime();
        
        if (companyInfo.loaded && companyInfo.lastFetchTime && 
            (currentTime - companyInfo.lastFetchTime) < CACHE_TIMEOUT) {
            return;
        }

        yield put(fetchCompanyInfoStart());
        const res = yield call(callWithAuth, getCompanyInfoApi, { operation: 'GET-INFO' });
        
        if (res.status && res.data) {
            yield put(fetchCompanyInfoSuccess(res.data));
        } else {
            yield put(fetchCompanyInfoFailure(res.errMsg || 'Failed to fetch company info'));
        }
    } catch (error) {
        yield put(fetchCompanyInfoFailure(error.message));
    }
}

export default function* companyInfoSaga() {
    yield takeLatest(loadCompanyInfoRequest.type, handleFetchCompanyInfo);
}
